export const UFS = [
    { description: "Acre", uf: "AC" },
    { description: "Alagoas", uf: "AL" },
    { description: "Amapá", uf: "AP" },
    { description: "Amazonas", uf: "AM" },
    { description: "Bahia", uf: "BA" },
    { description: "Ceará", uf: "CE" },
    { description: "Distrito Federal", uf: "DF" },
    { description: "Espírito Santo", uf: "ES" },
    { description: "Goiás", uf: "GO" },
    { description: "Maranhão", uf: "MA" },
    { description: "Mato Grosso", uf: "MT" },
    { description: "Mato Grosso do Sul", uf: "MS" },
    { description: "Minas Gerais", uf: "MG" },
    { description: "Paraná", uf: "PR" },
    { description: "Paraíba", uf: "PB" },
    { description: "Pará", uf: "PA" },
    { description: "Pernambuco", uf: "PE" },
    { description: "Piauí", uf: "PI" },
    { description: "Rio Grande do Norte", uf: "RN" },
    { description: "Rio Grande do Sul(*)", uf: "RS" },
    { description: "Rio de Janeiro", uf: "RJ" },
    { description: "Rondônia", uf: "RO" },
    { description: "Roraima", uf: "RR" },
    { description: "Santa Catarina", uf: "SC" },
    { description: "Sergipe", uf: "SE" },
    { description: "São Paulo", uf: "SP" },
    { description: "Tocantins", uf: "TO" }
];

export const UserGroups = Object.freeze({
  farmer: 'farmer',
  driver: 'driver',
  client: 'client',
  transporter: 'transporter',
  backoffice: 'backoffice',
  shiftManager: 'shift_manager',
  plantManager: 'plant_manager',
  dockManager: 'dock_manager',
  plantQuotaManager: 'plant_quota_manager',
  scheduler: 'scheduler',
  support: 'support',
  checkinAgent: 'check_in_agent'
});

export const schedulingStatus = Object.freeze({
  agendado: {
    id: 1,
    name: 'agendado'
  },
  atendimento: {
    id: 2,
    name: 'atendimento'
  },
  cancelado: {
    id: 4,
    name: 'cancelado'
  },
  concluido: {
    id: 5,
    name: 'concluido'
  },
  fila: {
    id: 6,
    name: 'fila'
  },
  atrasado: {
    id: 3,
    name:"atrasado"
  },
  chamado: {
    id: 7,
    name: "chamado"
  },
  reagendado: {
    id: 9,
    name: "reagendado"
  }
});
